import { useCallback } from 'react';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../helpers/formatters';
import TableCardMobile from '../../../molecules/Table/mobile/TableCard';
import { formatTimestamp } from '../formatters';
import Loader from '../../common/Loader';
import { decorateCexHistoryOrderStatus } from '../../../helpers/decorators';
import Badge from '../../../molecules/Badge';
import { historyOrderStatusToBadgeKlass } from './Table';
import { ICexHistoryOrder } from '.';
import NumberDisplay from '../../../molecules/NumberDisplay';
import { EXCHANGE_MAPPING } from '../../ConnectedWallet/SideBarWallet/CEXWallet/ExchangeSelector/helpers';
import { getExchangeNameFromType } from '../../../reducers/cex_trading';
import TableHeaderMobile from '../../../molecules/Table/mobile/TableHeader';

interface IOrdersHistoryTableMobileProps {
  orders: ICexHistoryOrder[];
  base: string;
  quote: string;
  loading: boolean;
  timezone?: string;
}

const OrdersHistoryTableMobile = ({
  orders,
  base,
  quote,
  loading,
  timezone,
}: IOrdersHistoryTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date closed',
        accessor: 'closed_at',
        parser: (value) => formatTimestamp(value, timezone),
        width: 130,
      },
      item_2: {
        name: 'Order type',
        accessor: 'type',
        parser: (value) => (value === 1 ? 'market' : 'limit'),
      },
    },
    row_2: {
      item_1: {
        name: `Amount ${base}`,
        accessor: 'base_amount',
        parser: (value) => <NumberDisplay value={value} string />,
        width: 130,
        string: true,
      },
      item_2: {
        name: `Filled ${base}`,
        accessor: 'fillBaseAmount',
        parser: (value) => <NumberDisplay value={value} string />,
        string: true,
      },
    },
    row_3: {
      item_1: {
        name: `Filled ${quote}`,
        accessor: 'fillQuoteAmount',
        parser: (value) => <NumberDisplay value={value} string />,
        width: 130,
        string: true,
      },
      item_2: {
        name: 'Average price',
        accessor: 'priceAvg',
        parser: (value) => <NumberDisplay value={value} string />,
        string: true,
      },
    },
    row_4: {
      item_1: {
        name: 'Status',
        accessor: 'status',
        parser: (value) => (
          <Badge
            variant='fill'
            klass={historyOrderStatusToBadgeKlass(value)}
            text={decorateCexHistoryOrderStatus(value)}
          />
        ),
        width: 130,
      },
      item_2: {
        name: 'Exchange',
        accessor: 'exchange',
        parser: (value) =>
          EXCHANGE_MAPPING[getExchangeNameFromType(value)].label,
      },
    },
  };

  const getColorForItem = useCallback((row: any) => {
    if (row.side === 1) {
      return 'green';
    } else {
      return 'red';
    }
  }, []);

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !orders.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        <>
          <TableHeaderMobile schema={schema} />
          {formatMobileTableData({
            data: orders,
            schema,
            getColorForItem,
          })?.map((row, index) => (
            <TableCardMobile key={index} data={row} />
          ))}
        </>
      )}
    </div>
  );
};

export default OrdersHistoryTableMobile;
